// Mapa: tipo de conector -> ícone do serviço. Importado pelo bundler (hash/cache).
import sql from './sql.png';
import s3 from './s3.webp';
import googleDrive from './google-drive.png';
import sharepoint from './sharepoint.jpg';
import whatsapp from './whatsapp.jpg';

const CONNECTOR_ICONS: Record<string, string> = {
  sql,
  sql_agent: sql,
  s3,
  google_drive: googleDrive,
  google_drive_managed: googleDrive,
  sharepoint,
  sharepoint_managed: sharepoint,
  whatsapp,
};

// Retorna a URL do ícone do conector, ou undefined (o componente usa um fallback).
export const connectorIcon = (type: string): string | undefined => CONNECTOR_ICONS[type];
